export function Header() {
  return <header>
    <h1>jk.id.lv</h1>
  </header>;
}
